import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './TagInput.css';
export const TagNumberInput = (props) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(props.value);
  const [edit, setEdit] = useState(props.edit);

  const onChange = (e) => {
    setValue(e.target.value);
  }

  const onClick = () => {
    setEdit(true);
    setValue(props.value);
  }

  if (!edit) {
    return (
      <div onClick={onClick} className="tag-input-display" data-testid="tag-input-display">
        <span className={props.value ? 'tag-input-label' : undefined}>{props.value ? `${t('tag_prefix')}-${props.value}` : '—'}</span>
        <span className="tag-input-edit-icon">&#10000;</span>
      </div>
    );
  }

  return (
    <input type="text" name="tag"
           placeholder={t('tag_number_placeholder')}
           required={props.required !== false}
           autoFocus
           value={value}
           onChange={onChange}
           onBlur={props.onBlur}
    />
  );
}
export default TagNumberInput;
